<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <NewWiringComponent/>

    </transition>
  </div>
</template>

<script>

import NewWiringComponent from '@/components/newWiringComponent.vue'

export default {
  name: 'Wiring',
  components: {
    NewWiringComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
